import React from 'react';
import './news.css';
import Render from './render';
import Actions from '../../actions';
import { TAPIRequestCanceller } from '../../services/api';
import { trackView } from '../../services/analytics';
import { connect } from 'react-redux';
import { FETCH_ARTICLES } from '../../constants/actions';

export interface IRequests {
  articles?: TAPIRequestCanceller;
  prevPageRequest?: TAPIRequestCanceller;
  nextPageRequest?: TAPIRequestCanceller;
}

class News extends React.Component<any> {
  private requests: IRequests = {};

  private defaultRequestParams = {
    fields: "*",
    limit: 6
  };

  private get dispatch() {
    return this.props.dispatch;
  }

  private get setPrevPageNumber() {
    return this.setPageNumber(this.props.pagination.page -= 1);
  }

  private get setNextPageNumber() {
    return this.setPageNumber(this.props.pagination.page += 1);
  }

  private setPageNumber = (pageNumber: number) =>  {
    return !!pageNumber && pageNumber > 0
      ? pageNumber
      : 1;
  }

  componentDidMount() {
    trackView('/news');
    this.requests.articles = this.getRequest();
  }

  componentWillUnmount() {
    Object.keys(this.requests)
      .forEach((request) => {
        this.requests[request].cancel();
      });
  }

  render() {
    return Render.call(this, this.props, this.state);
  }

  private getRequest(params: object = {}) {
    return Actions.get(this.dispatch, FETCH_ARTICLES, {
      ...this.defaultRequestParams,
      ...params
    });
  }

  private prevPage = () => {
    this.requests.prevPageRequest = this.getRequest({
      page: this.setPrevPageNumber
    });
  }

  private nextPage = () => {
    this.requests.nextPageRequest = this.getRequest({
      page: this.setNextPageNumber
    });
  }
}

const state = ({ articles: { articles, pagination } }) => ({
  articles,
  pagination
});

export default connect(state)(News);



// WEBPACK FOOTER //
// ./src/containers/News/index.tsx